"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var faCheckCircle_1 = require("@fortawesome/pro-solid-svg-icons/faCheckCircle");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var styles_1 = require("@mui/material/styles");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var getColor = function (theme, iconType) {
    var _a;
    return ({
        completed: (_a = theme.palette.green) === null || _a === void 0 ? void 0 : _a.contrastText,
        selected: theme.palette.primary.contrastText,
        standard: theme.palette.neutral.main,
    }[iconType]);
};
var CheckIcon = (0, styles_1.styled)(react_fontawesome_1.FontAwesomeIcon, {
    shouldForwardProp: function (prop) { return prop !== 'state'; },
})(function (_a) {
    var _b = _a.iconType, iconType = _b === void 0 ? 'standard' : _b, _c = _a.size, size = _c === void 0 ? 'md' : _c, theme = _a.theme;
    return ({
        marginRight: theme.spacing(1),
        color: getColor(theme, iconType),
        fontSize: size === 'sm' ? theme.typography.body2.fontSize : theme.typography.body1.fontSize,
        lineHeight: theme.typography.body1.fontSize,
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(CheckIcon, {
    icon: faCheckCircle_1.faCheckCircle,
});
